var map = {
	"./active.svg": 68371,
	"./deperso.svg": 57487,
	"./deperso_progress.svg": 59115,
	"./incomplete.svg": 25153,
	"./perso_progress.svg": 66234,
	"./perso_scheduled.svg": 22576,
	"./status/current.svg": 2777,
	"./status/deperso_current.svg": 6228,
	"./status/deperso_pending.svg": 65190,
	"./status/draft.svg": 68867,
	"./status/pending.svg": 16375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68487;